var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Field, Label, Radio, RadioGroup } from "@headlessui/react";
import { PencilSquareIcon } from "@heroicons/react/24/outline";
import { useContext, useState } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { WPQTIconButton } from "../../../../components/common/Button/Button";
import { LoadingOval } from "../../../../components/Loading/Loading";
import { WPQTModal } from "../../../../components/Modal/WPQTModal";
import { UPDATE_USER_PAGE_TASK_STAGE } from "../../../constants";
import { useTaskActions } from "../../../hooks/actions/useTaskActions";
import { UserPageTaskContext } from "../../../providers/UserPageTaskContextProvider";
function StageSelectionModal({ task, stages, pageHash, open, onClose }) {
    const { userTaskDispatch } = useContext(UserPageTaskContext);
    const [selectedStageId, setSelectedStageId] = useState(task.stage_id);
    const [loading, setLoading] = useState(false);
    const { changeTaskStage } = useTaskActions();
    const onSave = () => __awaiter(this, void 0, void 0, function* () {
        setLoading(true);
        yield changeTaskStage(task.task_hash, selectedStageId, pageHash, () => {
            userTaskDispatch({
                type: UPDATE_USER_PAGE_TASK_STAGE,
                payload: selectedStageId,
            });
        });
        setLoading(false);
        onClose();
    });
    return (_jsxs(WPQTModal, { modalOpen: open, closeModal: onClose, size: "sm", children: [_jsx("h3", { className: "wpqt-text-center", children: __("Task stage selection", "quicktasker") }), _jsx(RadioGroup, { value: selectedStageId, onChange: setSelectedStageId, className: "wpqt-flex wpqt-flex-col wpqt-items-center wpqt-gap-5", children: stages.map((stage) => (_jsxs(Field, { className: "wpqt-flex wpqt-items-center wpqt-gap-2", children: [_jsx(Radio, { value: stage.id, className: "wpqt-group wpqt-flex wpqt-size-5 wpqt-items-center wpqt-justify-center wpqt-rounded-full wpqt-border data-[checked]:wpqt-bg-blue-400", children: _jsx("span", { className: "wpqt-invisible wpqt-size-2 wpqt-rounded-full wpqt-bg-white group-data-[checked]:wpqt-visible" }) }), _jsx(Label, { children: stage.name })] }, stage.id))) }), _jsx("div", { className: "wpqt-mt-5 wpqt-flex wpqt-justify-center", children: loading ? (_jsx(LoadingOval, { width: "32", height: "32" })) : (_jsx(WPQTIconButton, { text: __("Save", "quicktasker"), icon: _jsx(PencilSquareIcon, { className: "wpqt-icon-green wpqt-size-5" }), onClick: onSave })) })] }));
}
export { StageSelectionModal };
